import { render, staticRenderFns } from "./UserProfileForm.vue?vue&type=template&id=21814f53&scoped=true&lang=html&"
import script from "./UserProfileForm.vue?vue&type=script&lang=js&"
export * from "./UserProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21814f53",
  null
  
)

export default component.exports